import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home.vue';
import Library from '../views/library.vue';
import Project from '../views/project.vue';
import Admin from '../views/admin.vue';
import SuggestionsList from '../views/suggestionsList.vue';
import SuggestionsListAdder from '../views/suggestionsListAdder.vue';
import SuggestionsListRequestedChanges from '../views/suggestionsListRequestedChanges.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/libraries/:libraryId',
    name: 'library',
    component: Library,
  },
  {
    path: '/projects/:projectId',
    name: 'project',
    component: Project,
  },
  {
    path: '/suggestionslists/:suggestionsListId/adder/:modality',
    name: 'suggestionsListAdder',
    component: SuggestionsListAdder,
  },
  {
    path: '/suggestionslists/:suggestionsListId/requestedchanges',
    name: 'suggestionsListRequestedChanges',
    component: SuggestionsListRequestedChanges,
  },
  {
    path: '/suggestionslists/:suggestionsListId',
    name: 'suggestionsList',
    component: SuggestionsList,
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
